/**
 * Odebrání mezer, převedení desetinné čárky na tečku apod. - unifikace na string - systémové číslo.
 */
export const unifyStringValueAsNumber = (text: string) => {
  if (!text) {
    return text;
  }
  return text
    .replaceAll(/\+/g, '')
    .replaceAll(/\s?/g, '')
    .replaceAll(/,/g, '.');
};

/**
 * Test zda předaný string je celé nebo desetinné číslo.
 * @param val text
 * @param supportNegate pokud je true, tak se i pro záporná čísla vrací true, jinak nejsou záporná čísla platná
 */
export const isFloat = (
  val: string,
  supportNegate: boolean,
  maxDigits?: number,
  maxFractionDigits?: number
) => {
  val = unifyStringValueAsNumber(val);
  const floatRegex = supportNegate
    ? /^-{0,1}\d*(?:[.]\d*?)?$/
    : /^\d*(?:[.]\d*?)?$/;

  if (!floatRegex.test(val)) {
    return false;
  }

  if (maxDigits !== undefined) {
    if (val.replaceAll(/[^0-9]/g, '').length > 16) {
      return false;
    }
  }
  if (maxFractionDigits !== undefined) {
    const n = val.indexOf('.');
    if (n >= 0 && val.substring(n + 1).length > maxFractionDigits) {
      return false;
    }
  }

  return true;
};

/**
 * Test zda předaný string je celé.
 * @param val text
 * @param supportNegate pokud je true, tak se i pro záporná čísla vrací true, jinak nejsou záporná čísla platná
 */
export const isInt = (
  val: string,
  supportNegate: boolean,
  maxDigits?: number
) => {
  val = unifyStringValueAsNumber(val);
  const intRegex = supportNegate ? /^-{0,1}\d*$/ : /^\d+$/;
  if (!intRegex.test(val)) {
    return false;
  }

  if (maxDigits !== undefined) {
    if (val.replaceAll(/[^0-9]/g, '').length > 16) {
      return false;
    }
  }

  return true;
};

/**
 * Převede číslo - počet číselných míst na hodnotu pro násobení, např. 3 - > 1000.
 * @param decimal počet míst
 */
export const decimalToMultiple = (decimal: number) => {
  switch (decimal) {
    case 0:
      return 1;
    case 1:
      return 10;
    case 2:
      return 100;
    case 3:
      return 1000;
    case 4:
      return 10000;
    case 5:
      return 100000;
    case 6:
      return 1000000;
    case 7:
      return 10000000;
    case 8:
      return 100000000;
    default:
      let num = 1;
      for (let a = 0; a < decimal; a++) {
        num = num * 10;
      }
      return num;
  }
};
